"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJwtExpireDate = exports.decodeJwtPayload = void 0;
/**
 * 解 JWT 的 payload
 *
 * 只解內容不驗簽章，僅供前端判斷 token 生命週期用，實際有效性仍以後端驗證為準。
 * @param {string} jwt
 * @returns {object|null} 格式不對時回傳 null
 */
const decodeJwtPayload = jwt => {
  if (typeof jwt !== "string") return null;
  const payload = jwt.split(".")[1];
  if (!payload) return null;
  try {
    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");
    const json = decodeURIComponent(window.atob(padded).split("").map(char => "%".concat("00".concat(char.charCodeAt(0).toString(16)).slice(-2))).join(""));
    return JSON.parse(json);
  } catch (error) {
    return null;
  }
};

/**
 * 取 JWT 的到期時間
 * @param {string} jwt
 * @returns {Date|null} 沒有 exp 或格式不對時回傳 null
 */
exports.decodeJwtPayload = decodeJwtPayload;
const getJwtExpireDate = jwt => {
  const {
    exp
  } = decodeJwtPayload(jwt) || {};
  if (typeof exp !== "number" || !Number.isFinite(exp)) return null;
  return new Date(exp * 1000);
};
exports.getJwtExpireDate = getJwtExpireDate;